import classNames from 'classnames';
import {Image} from '@shopify/hydrogen';

export const ProductImages = ({
  selectedImage,
  allImagesUrl,
  setSelectedImage,
}: {
  selectedImage: string;
  allImagesUrl: string[];
  setSelectedImage: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div>
      <Image
        src={selectedImage}
        alt="Product image"
        width={200}
        height={200}
        className={classNames(
          'w-[80vw]',
          'snap-start',
          'md:flex-shrink-none',
          'flex-shrink-0',
          'h-full',
          'object-cover',
          'object-center',
          'md:col-span-2',
          'md:w-full',
          'md:h-auto',
        )}
      />
      <div className="py-4">
        <div className={classNames('flex', 'flex-wrap', 'gap-4')}>
          {allImagesUrl.map((imageUrl) => {
            const isImageSelected = selectedImage === imageUrl;

            return (
              <Image
                key={`${imageUrl}`}
                src={imageUrl}
                alt={`productImage - ${imageUrl}`}
                aria-hidden="true"
                width={80}
                height={80}
                className={classNames('object-cover', 'h-20', 'w-20', {
                  'opacity-50': isImageSelected,
                })}
                onClick={() => setSelectedImage(imageUrl)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
